export const translations = {
  en: {
    nav: {
      home: "Home", newBikes: "New Bikes", usedBikes: "Used Bikes", eBikes: "E-Bikes",
      parts: "Parts", accessories: "Accessories", service: "Service", brands: "Brands",
      blog: "Blog", contact: "Contact", rental: "Rental",
      account: "Account", cart: "Cart", wishlist: "Wishlist",
      login: "Login", register: "Register", logout: "Logout",
    },
    hero: {
      overline: "Made in the Balkans. Engineered in Germany.",
      title: "Ride Beyond.",
      subtitle: "Premium bikes, e-bikes and parts — imported from Germany, delivered across the Balkans and Europe.",
      shopNew: "Shop New Bikes", exploreEbikes: "Explore E-Bikes",
    },
    home: {
      featured: "Featured", newArrivals: "New Arrivals", bestSellers: "Best Sellers",
      usedDeals: "Used Bike Deals", categories: "Shop by Category",
      latestBlog: "Latest from the Journal", reviews: "What Riders Say",
      newsletter: "Get the Weekly Ride", newsletterSub: "New arrivals, workshop tips, and exclusive deals — every Friday.",
      subscribe: "Subscribe", brandsTitle: "Trusted Brands",
    },
    product: {
      addToCart: "Add to Cart", buyNow: "Buy Now", inStock: "In stock", outOfStock: "Out of stock",
      specifications: "Specifications", reviews: "Reviews", relatedProducts: "You may also like",
      wishlist: "Wishlist",
    },
    cart: {
      title: "Your Cart", empty: "Your cart is empty.", continueShopping: "Continue Shopping",
      subtotal: "Subtotal", checkout: "Checkout", remove: "Remove", quantity: "Quantity",
    },
    checkout: {
      title: "Checkout", shipping: "Shipping Information", payment: "Payment Method",
      cod: "Cash on Delivery", bank: "Bank Transfer",
      placeOrder: "Place Order", name: "Full Name", address: "Address",
      city: "City", country: "Country", postal: "Postal Code", phone: "Phone", notes: "Order Notes (optional)",
      orderSuccess: "Order placed! Order #",
    },
    auth: {
      login: "Login", register: "Create Account", email: "Email", password: "Password",
      name: "Full Name", noAccount: "Don't have an account?", hasAccount: "Already have an account?",
    },
    rental: {
      title: "Bike & E-Bike Rental",
      subtitle: "Explore North Macedonia on premium bikes. Book online in seconds.",
      selectDates: "Select Dates", pickup: "Pickup Location", duration: "Duration",
      accessories: "Add-ons", insurance: "Rental Insurance (+€10/day)", total: "Total",
      book: "Book Now", tours: "Guided Tours", perDay: "/ day", available: "Available",
    },
    service: {
      title: "Professional Workshop", subtitle: "Certified mechanics. OEM parts. Fast turnaround.",
      bookService: "Book Service", serviceType: "Service Type", preferredDate: "Preferred Date",
      bikeDetails: "Bike Details (make, model, year)",
    },
    contact: {
      title: "Get in Touch", form: "Send us a message", subject: "Subject", message: "Message", send: "Send Message",
    },
    footer: {
      newsletter: "Newsletter", subscribe: "Subscribe",
      shop: "Shop", company: "Company", support: "Support",
      about: "About VELOTEKA", careers: "Careers", press: "Press",
      shipping: "Shipping", returns: "Returns", warranty: "Warranty",
      terms: "Terms", privacy: "Privacy",
      rights: "All rights reserved.",
    },
  },
  mk: {
    nav: {
      home: "Почетна", newBikes: "Нови Велосипеди", usedBikes: "Половни", eBikes: "Е-Велосипеди",
      parts: "Делови", accessories: "Опрема", service: "Сервис", brands: "Брендови",
      blog: "Блог", contact: "Контакт", rental: "Изнајмување",
      account: "Профил", cart: "Кошничка", wishlist: "Омилени",
      login: "Најави се", register: "Регистрирај се", logout: "Одјави се",
    },
    hero: {
      overline: "Направено на Балканот. Инженерирано во Германија.",
      title: "Вози Понатаму.",
      subtitle: "Премиум велосипеди, е-велосипеди и делови — увезени од Германија, доставени низ Балканот и Европа.",
      shopNew: "Купи Нови", exploreEbikes: "Истражи Е-Велосипеди",
    },
    home: {
      featured: "Издвоено", newArrivals: "Нови", bestSellers: "Најпродавани",
      usedDeals: "Половни Понуди", categories: "Категории",
      latestBlog: "Од Блогот", reviews: "Што велат возачите",
      newsletter: "Неделен Билтен", newsletterSub: "Нови производи, совети и понуди — секој петок.",
      subscribe: "Претплати се", brandsTitle: "Доверливи Брендови",
    },
    product: {
      addToCart: "Додај во Кошничка", buyNow: "Купи Сега", inStock: "На залиха", outOfStock: "Нема на залиха",
      specifications: "Спецификации", reviews: "Оцени", relatedProducts: "Слични производи",
      wishlist: "Омилени",
    },
    cart: {
      title: "Кошничка", empty: "Кошничката е празна.", continueShopping: "Продолжи со Купување",
      subtotal: "Вкупно", checkout: "Нарачај", remove: "Отстрани", quantity: "Количина",
    },
    checkout: {
      title: "Нарачка", shipping: "Информации за Достава", payment: "Начин на Плаќање",
      cod: "Плаќање при Достава", bank: "Банкарски Трансфер",
      placeOrder: "Заврши Нарачка", name: "Име и Презиме", address: "Адреса",
      city: "Град", country: "Држава", postal: "Поштенски Код", phone: "Телефон", notes: "Забелешки (по избор)",
      orderSuccess: "Нарачката е успешна! Број #",
    },
    auth: {
      login: "Најави се", register: "Регистрирај се", email: "Е-пошта", password: "Лозинка",
      name: "Име и Презиме", noAccount: "Немате профил?", hasAccount: "Имате профил?",
    },
    rental: {
      title: "Изнајмување на Велосипеди",
      subtitle: "Истражи ја Северна Македонија со премиум велосипеди. Резервирај онлајн.",
      selectDates: "Датуми", pickup: "Место за Подигнување", duration: "Времетраење",
      accessories: "Додатоци", insurance: "Осигурување (+€10/ден)", total: "Вкупно",
      book: "Резервирај", tours: "Водени Тури", perDay: "/ ден", available: "Достапен",
    },
    service: {
      title: "Професионален Сервис", subtitle: "Сертифицирани механичари. Оригинални делови.",
      bookService: "Резервирај Сервис", serviceType: "Тип на Сервис", preferredDate: "Дата",
      bikeDetails: "За велосипедот (модел, година)",
    },
    contact: {
      title: "Контактирај не", form: "Пиши ни", subject: "Наслов", message: "Порака", send: "Испрати",
    },
    footer: {
      newsletter: "Билтен", subscribe: "Претплати се",
      shop: "Продавница", company: "Компанија", support: "Поддршка",
      about: "За VELOTEKA", careers: "Кариера", press: "Медиуми",
      shipping: "Достава", returns: "Враќање", warranty: "Гаранција",
      terms: "Услови", privacy: "Приватност",
      rights: "Сите права задржани.",
    },
  },
  de: {
    nav: {
      home: "Start", newBikes: "Neue Bikes", usedBikes: "Gebraucht", eBikes: "E-Bikes",
      parts: "Ersatzteile", accessories: "Zubehör", service: "Werkstatt", brands: "Marken",
      blog: "Blog", contact: "Kontakt", rental: "Verleih",
      account: "Konto", cart: "Warenkorb", wishlist: "Wunschliste",
      login: "Anmelden", register: "Registrieren", logout: "Abmelden",
    },
    hero: {
      overline: "Auf dem Balkan gefertigt. In Deutschland konzipiert.",
      title: "Fahr Weiter.",
      subtitle: "Premium-Bikes, E-Bikes und Ersatzteile — importiert aus Deutschland, geliefert im gesamten Balkan und Europa.",
      shopNew: "Neue Bikes", exploreEbikes: "E-Bikes entdecken",
    },
    home: {
      featured: "Empfohlen", newArrivals: "Neuheiten", bestSellers: "Bestseller",
      usedDeals: "Gebrauchtbike Deals", categories: "Kategorien",
      latestBlog: "Aus dem Blog", reviews: "Was Fahrer sagen",
      newsletter: "Wöchentlicher Newsletter", newsletterSub: "Neuheiten, Werkstatt-Tipps und Angebote — jeden Freitag.",
      subscribe: "Abonnieren", brandsTitle: "Vertrauenswürdige Marken",
    },
    product: {
      addToCart: "In den Warenkorb", buyNow: "Jetzt kaufen", inStock: "Auf Lager", outOfStock: "Ausverkauft",
      specifications: "Spezifikationen", reviews: "Bewertungen", relatedProducts: "Das könnte Ihnen gefallen",
      wishlist: "Wunschliste",
    },
    cart: {
      title: "Warenkorb", empty: "Ihr Warenkorb ist leer.", continueShopping: "Weiter einkaufen",
      subtotal: "Zwischensumme", checkout: "Zur Kasse", remove: "Entfernen", quantity: "Menge",
    },
    checkout: {
      title: "Zur Kasse", shipping: "Versandinformationen", payment: "Zahlungsart",
      cod: "Nachnahme", bank: "Banküberweisung",
      placeOrder: "Bestellung aufgeben", name: "Vollständiger Name", address: "Adresse",
      city: "Stadt", country: "Land", postal: "PLZ", phone: "Telefon", notes: "Bestellhinweise (optional)",
      orderSuccess: "Bestellung erfolgreich! Nr #",
    },
    auth: {
      login: "Anmelden", register: "Konto erstellen", email: "E-Mail", password: "Passwort",
      name: "Vollständiger Name", noAccount: "Kein Konto?", hasAccount: "Bereits registriert?",
    },
    rental: {
      title: "Bike & E-Bike Verleih",
      subtitle: "Entdecken Sie Nordmazedonien auf Premium-Bikes. Online in Sekunden buchen.",
      selectDates: "Zeitraum wählen", pickup: "Abholort", duration: "Dauer",
      accessories: "Extras", insurance: "Versicherung (+€10/Tag)", total: "Gesamt",
      book: "Jetzt buchen", tours: "Geführte Touren", perDay: "/ Tag", available: "Verfügbar",
    },
    service: {
      title: "Profi-Werkstatt", subtitle: "Zertifizierte Mechaniker. OEM-Teile. Schnelle Bearbeitung.",
      bookService: "Termin buchen", serviceType: "Service-Typ", preferredDate: "Wunschdatum",
      bikeDetails: "Bike-Details (Marke, Modell, Jahr)",
    },
    contact: {
      title: "Kontakt aufnehmen", form: "Schreiben Sie uns", subject: "Betreff", message: "Nachricht", send: "Nachricht senden",
    },
    footer: {
      newsletter: "Newsletter", subscribe: "Abonnieren",
      shop: "Shop", company: "Unternehmen", support: "Support",
      about: "Über VELOTEKA", careers: "Karriere", press: "Presse",
      shipping: "Versand", returns: "Retouren", warranty: "Garantie",
      terms: "AGB", privacy: "Datenschutz",
      rights: "Alle Rechte vorbehalten.",
    },
  },
};

export const languageOptions = [
  { code: "en", label: "EN" },
  { code: "mk", label: "MK" },
  { code: "de", label: "DE" },
];
